import { validateTidalLicense } from "../../../base/index.js";
import "./editorToolbarToggleButton.tidal.theme.js";
import {
  EditorToolbarToggleButton,
  editorToolbarToggleButtonClasses
} from "./EditorToolbarToggleButton.js";
validateTidalLicense();
export {
  EditorToolbarToggleButton,
  editorToolbarToggleButtonClasses
};
//# sourceMappingURL=index.js.map
